import {useSchemaListCodelistIds} from 'schema';
import {useAgentSchemas} from 'schemas';

export const useAgentsCodelistIds = () => {
  const agentSchemas = useAgentSchemas();

  return useSchemaListCodelistIds(agentSchemas);
};
